import AdminDashboard from "./AdminDashboard";
export default function SuperAdminDashboard() {
  return <AdminDashboard isSuper />;
}
